<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId">
        <template v-slot:actions>
          <a-space>
            <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
          </a-space>
        </template>
      </project-page-header>
      <div class="page-title">项目报告</div>
      <div class="panel-body">
        <div class="w600">
          <a-steps progress-dot class="v-my-md" size="small" :current="currentStep" v-if="record.state < 9">
            <a-step title="提交项目报告">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state > 0">
                <div>{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目主管审核">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="record.state == 3">
                <div>{{ record.checkTime ? record.checkTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="完成" />
          </a-steps>
        </div>
        <div class="w800" v-if="record.checkResult == -1">
          <a-alert class="v-mb-sm no-border" type="error">
            <div slot="message">
              <div class="font-md text-darkblue flex items-center">
                <a-icon type="alert" class="v-mr-xs" />
                此项目报告已被驳回
              </div>
              <div class="flex v-mt-xs">
                <span class="text-right text-grey">审核意见：</span>
                <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
              </div>
            </div>
          </a-alert>
        </div>
        <div class="w800">
          <div class="flex items-center v-pa-sm bg-orange-1 v-mb-lg">
            <b>报告名称：{{ record.reportName }}</b>
            <!-- <div>报告提交时间：{{ record.submitTime ? record.submitTime.substring(0, 16) : '' }}</div> -->
            <a-space class="v-ml-auto" :size="10">
              <div class="text-indigo flex items-center hover-line" @click="exportWord">
                <img class="file-img v-mr-xs" src="~@/assets/images/file_word.svg" width="16" />
                导出为word
              </div>
              <div class="text-indigo flex items-center hover-line" @click="exportPdf">
                <img class="file-img v-mr-xs" src="~@/assets/images/file_pdf.svg" width="16" />
                导出为pdf
              </div>
            </a-space>
          </div>
          <!-- 
            <div class="reportsummary" v-html="record.content"></div>
            :html-to-pdf-options="{
              margin: 25,
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            }"
            
            :html-to-pdf-options="{
              image: { type: 'jpeg', quality: 0.98 },
              jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            }"
           -->
          <vue-html2pdf
            :show-layout="false"
            :preview-modal="false"
            :float-layout="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            :paginate-elements-by-height="1100"
            :pdf-quality="2"
            :filename="exportFilename"
            :manual-pagination="true"
            @progress="onPdfProgress"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              <div class="pdf-padding">
                <!-- <div class="reportsummary" v-html="record.content"></div> -->
                <editor id="myedit" ref="editor" :project-id="projectId" disabled :options="{ inline: true, hidden_input: false }" v-model="record.content" />
              </div>
            </section>
          </vue-html2pdf>
          <editor id="myedit" ref="editor" :project-id="projectId" disabled :options="{ inline: true, hidden_input: false }" v-model="record.content" />
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(record.state)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-if="record.state == 1">审核通过，提交主管审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" @click="handleConfirmReview" v-else-if="record.state == 2">审核通过</a-button>
            </template>
            <template v-if="hasPermission('project:funded:summaryReport:delete') && (record.state == 0 || record.state == 9)">
              <a-button type="danger" :loading="saving" @click="handleRemove">
                <i class="fa fa-trash-o v-mr-sm"></i>
                删除
              </a-button>
            </template>
            <a-button icon="left" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回项目报告" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 0)" v-if="[1, 2].includes(record.state)">确认驳回，退回至提交人</a-button>
          <!-- <a-button type="indigo" :loading="saving" @click="handleReview(false, record.state - 1)" v-if="record.origin == 2 && [2, 3].includes(record.state)">确认驳回，退回至官员</a-button> -->
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import $ from 'jquery'
import Editor from './editor'
import ProjectPageHeader from '../common/page-header'
import { getReport, delSummaryReport, reviewReport } from '@/api/project/common'
require('@/assets/js/jquery.wordexport')
export default {
  name: 'FundedProjectReportDetail',
  components: {
    ProjectPageHeader,
    Editor,
    VueHtml2pdf,
  },
  data() {
    return {
      currentStep: 0,
      projectId: +this.$route.query.id,
      reportId: +this.$route.query.rid,
      loading: false,
      saving: false,
      record: {},
      rejectModal: false,
      rejectReason: '',
      exportingPdf: null,
    }
  },
  computed: {
    project: vm => vm.$store.state.app.project,
    exportFilename: vm => `${vm.project && vm.project.name}_${vm.record && vm.record.reportName}`,
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, rid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (rid) {
        this.reportId = +rid
        this.loadRecord()
      }
    },
    loadRecord() {
      getReport(this.reportId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
          let { state, origin } = data.result
          if (state == 0 || state == -1) {
            this.currentStep = 0
          } else {
            this.currentStep = state == 9 ? (origin == 1 ? 2 : 3) : origin == 1 ? state - 1 : state
          }
        }
      })
    },
    handleRemove() {
      let { reportId, projectId } = this
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.$message.destroy()
          return new Promise((resolve, reject) => {
            delSummaryReport(reportId, projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.go(-1)
                resolve()
              } else {
                this.$message.warn(data.msg)
                reject()
              }
            })
          })
        },
      })
    },
    pdfOptions() {
      return {
        margin: 25,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        // filename: this.fileName
      }
    },
    onPdfProgress(percent) {
      console.log('onPdfProgress', percent)
      if (percent == 100) {
        setTimeout(this.exportingPdf, 200)
      }
    },
    exportWord() {
      let { name } = this.project
      let { reportName } = this.record
      $('#myedit').wordExport(`${name}_${reportName}`)
    },
    exportPdf() {
      this.exportingPdf = this.$message.loading('正在导出..', 0)
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 100)
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { reportId: id, projectId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        id,
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewReport(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.cancelRejectModal()
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
